export default "__VITE_ASSET__DBUnz7Bj__"